import { transform } from "node-json-transform";

export function buildContactGroup(data) {
  const map = {
    item: {
      id: "depId",
      name: "name",
      num: "num",
      parentId: "parentId"
    }
  };
  return transform(data, map);
}

export function buildContactAddress(data) {
  const map = {
    item: {
      id: "contactId",
      groupId: "depId",
      name: "contactName",
      phone: "contactPhone",
      error: "contactError",
      email: "contactEmail",
      role: "contactRole",
      countryCode: "contactCountry",
      areaCode: "contactAreaCode",
      billingCode: "billingCode",
      depName: "depName",
      department: "department"
    },
    operate: [
      {
        run: function(ary) {
          return ary === null ? "" : ary;
        },
        on: "depName"
      },
      {
        run: function(ary) {
          return ary === null ? "" : ary;
        },
        on: "department"
      },
      {
        run: function(ary) {
          return ary === null ? "" : ary;
        },
        on: "contactEmail"
      },
      {
        run: function(ary) {
          return ary === null ? "" : ary;
        },
        on: "contactError"
      }
    ]
  };
  return transform(data, map);
}
